import { render } from "./App.vue?vue&type=template&id=6288c8b5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WORKSPACE\\Netbeans\\lz06\\2022xiongmao\\xiongmao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__